const config = {
  APP: {
    API_URL: process.env.REACT_APP_API_URL,
    RECAPTCHA_KEY: process.env.REACT_APP_RECAPTCHA_KEY_CLIENT,
  },
};
export default config;
